<template>
  <v-container>
    <l-map
      :style="`height: ${mapheight}; width: ${mapwitdh};z-index:1`"
      :zoom="zoom"
      :center="currentCenter"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @update:bounds="boundsUpdated"
    >
      <template v-for="(latlong,index) in markerLatLng">
        <l-marker
          :key="index"
          :options="markerOptions"
          :lat-lng="latlong"
          @click="sendChoosenDevice(index)"
        >
          <l-tooltip  v-if="tooltips!=undefined && tooltips.length>0">
            <div :style="`max-height: 500px; max-width: 500px;overflow: hidden;`">
            <vue-json-pretty :data="tooltips[index]"></vue-json-pretty>
            </div>
          </l-tooltip>
        </l-marker>
      </template>
      <l-tile-layer :url="url"></l-tile-layer>
      <l-control position="bottomleft">
        <v-btn
          @click="reset(toCenterLatLong)"
          class="text-button"
          color="primary"
        >{{$t('DataHome.center')}}</v-btn>
      </l-control>
      <l-control v-if="countDevice>=0" position="topright">
        <v-alert border="left" type="info" icon="mdi-access-point" dense>
          <span v-if="countDevice>=1">Devices : {{countDevice}}</span>
          <span v-else>Device : {{countDevice}}</span>
        </v-alert>
      </l-control>
    </l-map>
  </v-container>
</template>

<script>
import { LMap, LTileLayer, LMarker, LTooltip, LControl } from "vue2-leaflet";
import { Icon } from "leaflet";
import VueJsonPretty from "vue-json-pretty";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LControl,
    VueJsonPretty
  },
  props: {
    markerLatLng: Array,
    mapheight: String,
    mapwitdh: String,
    center: Array,
    recenter: Boolean,
    toCenterLatLong: Array,
    tooltips: Array,
    countDevice: Number
  },

  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      bounds: null,
      zoom: 5,
      currentCenter: [],
      markerOptions: { interactive: false }
      //center: [47.41322, 7.219482]
      //markerLatLng:[47.31322, -1.319482],
    };
  },
  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.currentCenter = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    reset(center) {
      this.currentCenter = center;
    },
    sendChoosenDevice(value) {
      this.$emit("clickmarker", this.tooltips[value]);
    }
  },
  watch: {
    recenter: function(value) {
      if (value) {
        (this.currentCenter = this.center), this.$emit("recenter");
      }
    },
    tooltips: function(array) {
      if (array.length > 0) {
        this.markerOptions.interactive = true;
      } else {
        this.markerOptions.interactive = false;
      }
    }
  },
  beforeMount: function() {
    this.currentCenter = this.center;
  }
};
</script>
